module.exports = __webpack_public_path__ + "other-8fb8ef664335ca092b8ef304cc920ddc.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/file-formats/other.svg
// module id = 44
// module chunks = 0